import {useMutation} from "@tanstack/react-query";
import {API} from "../../api";

export const useCreateFeatureMutation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: API.createFeatureFlag,
    onSuccess,
    onError: (err) => {
      if (onError) {
        onError(err);
      }
      console.error(err);
    },
  });
};
